/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
import React from 'react';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @material-ui/icons
import SwapHoriz from '@material-ui/icons/SwapHoriz';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';

import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import Card from 'components/Card/Card.jsx';

import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Datetime from 'react-datetime';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import purple from '@material-ui/core/colors/purple';
import Danger from 'components/Typography/Danger.jsx';
import Typography from '@material-ui/core/Typography';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
// Firebase
import InfoIcon from '@material-ui/icons/Info';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import swal from 'sweetalert';
import AddTruckersStyle from 'assets/jss/material-dashboard-pro-react/views/AddTruckersStyle.jsx';
import firebase from '../../config/config';
import apiCaller from '../../utils/apiCallerOutstanding';
import './autoSelect.css';
import FeatureFlagToastAlert from '../Components/FeatureFlagToastAlert';
import OtherExpenses from './Sections/TripCalculation/OtherExpenses';
import TripDeductionFields from './Sections/TripCalculation/TripDeductionFields';
import currencyFormat from '../../utils/toIndianCurrencyString';
import CreditLimitEditDialog from '../Transporters/Section/TransporterNewFields/CreditLimitEditDialog';
import { mappedCurrentActiveRole } from '../../utils/roleMapping';
import logger from '../../utils/logger';
import getFirstEightChars from '../../utils/getFirstEightChars';
import { isEightDigitAlphaNumeric } from '../../utils/regexValidator';

const db = firebase.firestore();
const addTransaction = firebase
  .functions()
  .httpsCallable('transactions-addTransaction');
const auditLog = firebase.functions().httpsCallable('utilities-auditLog');

class AddTransactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transporterNameState: '',
      truckerNameState: '',
      fromCityState: '',
      toCityState: '',
      amountState: '',
      commissionState: '',
      bthReceivableState: '',
      bthPayableState: '',
      athReceivableState: '',
      athPayableState: '',
      truckNumberState: '',
      isLoading: false,
      alert: null,
      athReceivableDate: moment(),
      athPayableAutoCalculated: '0',
      bthPayableAutoCalculated: '0',
      truckerATHPercentage: '0',
      truckerBTHPercentage: '0',
      expectedDate: '',
      driverNumberState: '',
      expectedDateState: '',
      featureFlagFiles: '',
      showTds: true,
      hardCodeTransactionNumber: 95670,
      latestTransactionNumber: '',
      tdsTruckerSubmitted: true,
      validPan: true,
      ewayBillNumber: '',
      creditLimitEditDialog: false,
      branchCreditLimit: {},
      isCreditLimitExceeding: false,
      indentNumber: '',
      indentDetails: null,
      advanceBonusTrucker: 0,
      advanceBonusPaidByTrucker: false,
      advanceChargesTruckerAmount: 0,
      advanceChargesTruckerShowinloadingslip: false,
      earlySettlementSmartClubMembershipBonusPaidByTrucker: false,
      earlySettlementSmartClubMembershipBonusTrucker: 0,
      writeOffDeductionTruckerAmount: 0,
      writeOffDeductionTransporterAmount: 0,
      isPodSubmittedAtUnloadingPoint: false,
      softPodAcceptedByTransporter: false,
      isPodSubmittedAtUnloadingPointDisabled: false,
      softPodAcceptedByTransporterDisabled: false,
    };
    this.submitTransaction = this.submitTransaction.bind(this);
    this.validateAllFields = this.validateAllFields.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.athReceivableDateChange = this.athReceivableDateChange.bind(this);
    this.expectedDateChange = this.expectedDateChange.bind(this);
    this.otherExpenses = this.otherExpenses.bind(this);
    this.deductions = this.deductions.bind(this);
    this.confirmAlert = this.confirmAlert.bind(this);
    this.setCreditLimitEditDialog = this.setCreditLimitEditDialog.bind(this);
  }

  componentDidMount() {
    this.getFeatureFlagStatus();
  }

  getFeatureFlagStatus() {
    db.collection('FeatureFlags')
      .doc('FileUploadsFeature')
      .onSnapshot(doc => {
        if (doc.exists) {
          const data = doc.data();
          this.setState({ featureFlagFiles: data?.transactionFiles });
        }
      });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  confirmAlert() {
    const { activeRole } = this.props;
    // Set the CurrentTransaction in Redux Store
    // eslint-disable-next-line react/destructuring-assignment
    this.setState({
      alert: null,
    });
    // eslint-disable-next-line react/destructuring-assignment
    this.props.history.push(`/${activeRole}/transactions/view`);
  }

  // function that verifies if value contains only numbers
  verifyNumber(value) {
    const numberRex = new RegExp('^[0-9]+$');
    return numberRex.test(value);
  }

  verifyNumberAndGreater(value, minValue) {
    const numberRex = new RegExp('^[0-9]+$');
    if (numberRex.test(value) && value >= minValue) {
      return true;
    }
    return false;
  }

  verifyDriverNumber(value) {
    const numberRex = /^[6-9][0-9]{9}$/;
    if (numberRex.test(value) && value.length === 10) {
      return true;
    }
    return false;
  }

  verifyMaxNumber(value, maxValue) {
    const numberRex = new RegExp('^[0-9]+$');
    if (numberRex.test(value) && value <= maxValue) {
      return true;
    }
    return false;
  }

  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  verifyPhoneNumber(value) {
    const validatephoneNumberNumberRegex = /^[6-9][0-9]{9}$/;
    if (validatephoneNumberNumberRegex.test(value) && value.length === 10) {
      return true;
    }
    return false;
  }

  handleChangeUnloadingPoint = event => {
    this.setState({
      isPodSubmittedAtUnloadingPoint: event.target.value === 'true',
    });
  };

  handleChangeSoftPodAcceptedByTransporter = event => {
    this.setState({
      softPodAcceptedByTransporter: event.target.value === 'true',
    });
  };

  applyPodSettingsFromIndent = indentDetails => {
    if (!indentDetails) {
      this.setState({
        isPodSubmittedAtUnloadingPoint: false,
        softPodAcceptedByTransporter: false,
        isPodSubmittedAtUnloadingPointDisabled: false,
        softPodAcceptedByTransporterDisabled: false,
      });
      return;
    }

    const podEnabled = indentDetails?.pod_submitted_at_unloading_point_enabled;
    const softPodEnabled =
      indentDetails?.soft_pod_accepted_by_transporter_enabled;
    const podState = {};

    if (podEnabled === 'fully') {
      podState.isPodSubmittedAtUnloadingPoint = true;
      podState.isPodSubmittedAtUnloadingPointDisabled = true;
    } else {
      podState.isPodSubmittedAtUnloadingPoint =
        indentDetails?.is_pod_submitted_at_unloading_point ?? false;
      podState.isPodSubmittedAtUnloadingPointDisabled = false;
    }

    if (softPodEnabled === 'fully') {
      podState.softPodAcceptedByTransporter = true;
      podState.softPodAcceptedByTransporterDisabled = true;
    } else {
      podState.softPodAcceptedByTransporter =
        indentDetails?.soft_pod_accepted_by_transporter ?? false;
      podState.softPodAcceptedByTransporterDisabled = false;
    }

    this.setState(podState);
  };

  calculateFields() {
    const { indentDetails } = this.state;

    const bthReceivable = indentDetails?.bth_receivable;

    if (this.verifyNumber(bthReceivable))
      this.setState({
        bthReceivableState: 'success',
      });
    else
      this.setState({
        bthReceivableState: 'This field is required',
      });

    if (this.verifyNumber(indentDetails?.ath_payable))
      this.setState({
        athPayableState: 'success',
      });
    else
      this.setState({
        athPayableState: 'This field is required',
      });

    if (this.verifyNumber(indentDetails?.bth_payable))
      this.setState({
        bthPayableState: 'success',
      });
    else
      this.setState({
        bthPayableState: 'This field is required',
      });

    //  Total Payable Calculation
    let payableDeductions = 0;
    if (Number(indentDetails?.challan_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.challan_trucker_amount);
    if (Number(indentDetails?.penalty_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.penalty_trucker_amount);

    if (Number(indentDetails?.tds_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.tds_trucker_amount);
    if (Number(indentDetails?.doc_charges_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.doc_charges_trucker_amount);
    if (Number(indentDetails?.maamol_charges_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.maamol_charges_trucker_amount);
    if (Number(indentDetails?.shortage_charges_trucker_amount) > 0)
      payableDeductions += Number(
        indentDetails?.shortage_charges_trucker_amount
      );
    if (Number(indentDetails?.late_delivery_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.late_delivery_trucker_amount);
    if (Number(indentDetails?.late_pod_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.late_pod_trucker_amount);
    if (Number(indentDetails?.early_settlement_trucker_amount) > 0)
      payableDeductions += Number(
        indentDetails?.early_settlement_trucker_amount
      );
    if (Number(indentDetails?.fuel_charges_trucker_amount) > 0)
      payableDeductions += Number(indentDetails?.fuel_charges_trucker_amount);

    let receivableDeductions = 0;
    if (Number(indentDetails?.challan_transporter_amount) > 0)
      receivableDeductions += Number(indentDetails?.challan_transporter_amount);
    if (Number(indentDetails?.fuel_charges_transporter_amount) > 0)
      receivableDeductions += Number(
        indentDetails?.fuel_charges_transporter_amount
      );
    if (Number(indentDetails?.tds_transporter_amount) > 0)
      receivableDeductions += Number(indentDetails?.tds_transporter_amount);
    if (Number(indentDetails?.doc_charges_transporter_amount) > 0)
      receivableDeductions += Number(
        indentDetails?.doc_charges_transporter_amount
      );
    if (Number(indentDetails?.penalty_transporter_amount) > 0)
      receivableDeductions += Number(indentDetails?.penalty_transporter_amount);
    if (Number(indentDetails?.maamol_charges_transporter_amount) > 0)
      receivableDeductions += Number(
        indentDetails?.maamol_charges_transporter_amount
      );

    let otherExpensesReceivable = 0;
    if (
      indentDetails?.loading_charges_paid_by_transporter &&
      Number(indentDetails?.loading_charges_transporter) > 0
    ) {
      otherExpensesReceivable += Number(
        indentDetails?.loading_charges_transporter
      );
    }
    if (
      indentDetails?.unloading_charges_paid_by_transporter &&
      Number(indentDetails?.unloading_charges_transporter) > 0
    ) {
      otherExpensesReceivable += Number(
        indentDetails?.unloading_charges_transporter
      );
    }

    if (
      indentDetails?.hamali_charges_paid_by_transporter &&
      Number(indentDetails?.hamali_charges_transporter) > 0
    ) {
      otherExpensesReceivable += Number(
        indentDetails?.hamali_charges_transporter
      );
    }

    if (
      indentDetails?.unloading_halting_charges_paid_by_transporter &&
      Number(indentDetails?.unloading_halting_charges_transporter) > 0
    ) {
      otherExpensesReceivable += Number(
        indentDetails?.unloading_halting_charges_transporter
      );
    }

    if (
      indentDetails?.halting_charges_paid_by_transporter &&
      Number(indentDetails?.halting_charges_transporter) > 0
    ) {
      otherExpensesReceivable += Number(
        indentDetails?.halting_charges_transporter
      );
    }

    let otherExpensesPaidByTrucker = 0;
    if (
      indentDetails?.loading_charges_paid_by_trucker &&
      Number(indentDetails?.loading_charges_trucker) > 0
    )
      otherExpensesPaidByTrucker += Number(
        indentDetails?.loading_charges_trucker
      );
    if (
      indentDetails?.unloading_charges_paid_by_trucker &&
      Number(indentDetails?.unloading_charges_trucker) > 0
    )
      otherExpensesPaidByTrucker += Number(
        indentDetails?.unloading_charges_trucker
      );
    if (
      indentDetails?.hamali_charges_paid_by_trucker &&
      Number(indentDetails?.hamali_charges_trucker) > 0
    )
      otherExpensesPaidByTrucker += Number(
        indentDetails?.hamali_charges_trucker
      );
    if (
      indentDetails?.halting_charges_paid_by_trucker &&
      Number(indentDetails?.halting_charges_trucker) > 0
    )
      otherExpensesPaidByTrucker += Number(
        indentDetails?.halting_charges_trucker
      );
    if (
      indentDetails?.unloading_halting_charges_paid_by_trucker &&
      Number(indentDetails?.unloading_halting_charges_trucker) > 0
    )
      otherExpensesPaidByTrucker += Number(
        indentDetails?.unloading_halting_charges_trucker
      );

    const totalPayableAmount =
      Number(indentDetails?.ath_payable) +
      Number(indentDetails?.bth_payable) -
      Number(payableDeductions) +
      Number(otherExpensesPaidByTrucker);
    // + otherExpensesPayable;
    const totalReceivableAmount =
      Number(indentDetails?.ath_receivable) +
      Number(bthReceivable) -
      receivableDeductions +
      otherExpensesReceivable;

    const athPayableAutoCalculated =
      indentDetails?.ath_payable - payableDeductions; // + otherExpensesPayable;
    const bthPayableAutoCalculated =
      Number(indentDetails?.bth_payable) + Number(otherExpensesPaidByTrucker);
    const calculatedCommision = totalReceivableAmount - totalPayableAmount;
    this.setState({
      totalPayableAmount,
      totalReceivableAmount,
      netCommission: calculatedCommision,
      athPayableAutoCalculated,
      bthPayableAutoCalculated,
    });
  }

  handleTruckerATHPercentage(val, commission, amount) {
    // Convert strings to numbers
    const numericAmount = parseInt(amount);
    const numericCommission = parseInt(commission);
    if (numericAmount !== 0 && numericCommission !== 0) {
      const payable = numericAmount - numericCommission;

      // Check if payable is positive before calculating the percentage
      if (payable > 0) {
        const percentage = Math.round((val / payable) * 100);
        this.setState({ truckerATHPercentage: percentage });
      } else {
        this.setState({ truckerATHPercentage: 0 }); // Set percentage to 0 if payable is not positive
      }
    }
  }

  handleTruckerBTHPercentage(val, commission, amount) {
    // Convert strings to numbers
    const numericAmount = parseInt(amount);
    const numericCommission = parseInt(commission);
    if (numericAmount !== 0 && numericCommission !== 0) {
      const payable = numericAmount - numericCommission;

      // Check if payable is positive before calculating the percentage
      if (payable > 0) {
        const percentage = Math.round((val / payable) * 100);
        this.setState({ truckerBTHPercentage: percentage });
      } else {
        this.setState({ truckerBTHPercentage: 0 }); // Set percentage to 0 if payable is not positive
      }
    }
  }

  handleTruckerATH(amount, comm) {
    const result = amount - comm;
    let truckerATH = Math.round(result * 0.85);
    let truckerBTH = Math.round(result - truckerATH);
    this.handleTruckerATHPercentage(truckerATH, comm, amount);
    this.handleTruckerBTHPercentage(truckerBTH, comm, amount);
  }

  setCreditLimitEditDialog = value => {
    this.setState({ creditLimitEditDialog: value });
  };

  // validates all required fields and returns a promise
  validateAllFields() {
    const { classes } = this.props;
    const { expectedDate, indentDetails } = this.state;
    let error = false;
    let errorReason = '';
    return new Promise((resolve, reject) => {
      // Verify  Transporter Name
      if (this.verifyLength(indentDetails?.transporter_name, 1)) {
        this.setState({
          transporterNameState: 'success',
        });
      } else {
        this.setState({ transporterNameState: 'This field is required' });
        error = true;
        errorReason = ' transporterName validation fail';
      }

      // Verify  Trucker Name
      if (this.verifyLength(indentDetails?.trucker_name, 1)) {
        this.setState({
          truckerNameState: 'success',
        });
      } else {
        this.setState({ truckerNameState: 'This field is required' });
        error = true;
        errorReason = ' trucker name validation fail';
      }

      if (this.verifyLength(indentDetails?.branch, 1)) {
        this.setState({
          branchState: 'success',
        });
      } else {
        this.setState({ branchState: 'This field is required' });
        error = true;
        errorReason = ' branch validation fail';
      }

      // Verify  From City
      if (this.verifyLength(indentDetails?.from_location, 1)) {
        this.setState({
          fromCityState: 'success',
        });
      } else {
        this.setState({ fromCityState: 'This field is required' });
        error = true;
        errorReason = ' from city validation fail';
      }
      // Verify  To City
      if (this.verifyLength(indentDetails?.to_location, 1)) {
        this.setState({
          toCityState: 'success',
        });
      } else {
        this.setState({ toCityState: 'This field is required' });
        error = true;
        errorReason = ' to city validation fail';
      }
      // Verify Supply ID
      if (!this.verifyLength(indentDetails?.supply_id, 1)) {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Please check Supply ID
            </SweetAlert>
          ),
        });
        error = true;
        errorReason = 'Supply ID mandatory';
      }
      // Verify Demand ID
      if (!this.verifyLength(indentDetails?.demand_id, 1)) {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Please check Demand ID
            </SweetAlert>
          ),
        });
        error = true;
        errorReason = 'Demand ID mandatory';
      }

      // Verify  Amount
      if (this.verifyNumberAndGreater(indentDetails?.transporter_freight, 1)) {
        this.setState({
          amountState: 'success',
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              The Truck hire must be a minimum of Rs 1.
            </SweetAlert>
          ),
          amountState: 'This field is required',
        });
        error = true;
        errorReason = ' Truck hire validation fail';
      }
      // Verify  Commission
      if (this.verifyNumber(indentDetails?.gross_margin)) {
        this.setState({
          commissionState: 'success',
        });
      } else {
        this.setState({ commissionState: 'This field is required' });
        error = true;
        errorReason = ' commission validation fail';
      }

      // Verify  BTH Payable
      if (this.verifyNumber(indentDetails?.bth_payable)) {
        this.setState({
          bthPayableState: 'success',
        });
      } else {
        this.setState({ bthPayableState: 'This field is required' });
        error = true;
        errorReason = ' bth payable validation fail';
      }
      // Verify  BTH receivable
      if (this.verifyNumber(indentDetails?.bth_receivable)) {
        this.setState({
          bthReceivableState: 'success',
        });
      } else {
        this.setState({ bthReceivableState: 'This field is required' });
        error = true;
        errorReason = ' bth receivable validation fail';
      }
      // Verify  Commission
      if (this.verifyMaxNumber(indentDetails?.ath_payable, 199999)) {
        this.setState({
          athPayableState: 'success',
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Trucker ATH Limit Exceeded
            </SweetAlert>
          ),
          athPayableState: 'Trucker ATH Limit Exceeded',
        });
        error = true;
        errorReason = ' ath payable validation fail';
      }

      // Verify  Commission
      if (this.verifyNumber(indentDetails?.ath_receivable)) {
        this.setState({
          athReceivableState: 'success',
        });
      } else {
        this.setState({ athReceivableState: 'This field is required' });
        error = true;
        errorReason = ' ath receivable validation fail';
      }
      // Verify  Truck Number
      if (this.verifyLength(indentDetails?.truck_number, 1)) {
        this.setState({ truckNumberState: 'success' });
      } else {
        this.setState({ truckNumberState: 'This field is required' });
        error = true;
        errorReason = ' truck number validation fail';
      }
      // Verify whether the amount is less the commission
      if (
        parseInt(indentDetails?.transporter_freight, 10) <
        parseInt(indentDetails?.gross_margin, 10)
      ) {
        this.setState({
          commissionState: 'This field is required',
        });
        error = true;
        errorReason = ' commission validation fail';
      }

      // Verify expected date
      if (
        this.verifyLength(
          expectedDate ? expectedDate?.format('MMM Do YY') : '',
          1
        )
      ) {
        this.setState({
          expectedDateState: 'success',
        });
      } else {
        this.setState({ expectedDateState: 'This field is required' });
        error = true;
        errorReason = ' expected date validation fail';
      }
      // Verify driverNumber
      if (this.verifyPhoneNumber(indentDetails?.driver_number)) {
        this.setState({
          driverNumberState: 'success',
        });
      } else {
        this.setState({ driverNumberState: 'This field is required' });
        error = true;
        errorReason = ' driver number validation fail';
      }

      // Verify Tat Express Time
      if (indentDetails?.is_express) {
        if (
          !this.verifyNumber(indentDetails?.express_duration) ||
          Number(indentDetails?.express_duration) <= 0
        ) {
          this.setState({
            alert: (
              <SweetAlert
                error
                style={{ display: 'block', marginTop: '-100px' }}
                title="Error"
                onConfirm={() => this.hideAlert()}
                confirmBtnCssClass={`${classes.button} ${classes.success}`}
              >
                TAT Express Time is required.
              </SweetAlert>
            ),
          });
          error = true;
          errorReason = 'TAT Express Time validation fail';
        }
      }

      if (!error) {
        if (this.checkValues()) {
          resolve(true);
        } else {
          this.setState({
            alert: (
              <SweetAlert
                warning
                style={{ display: 'block', marginTop: '-100px' }}
                title="Warning"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnCssClass={`${classes.button} ${classes.success}`}
              >
                Please verify your calculations.
              </SweetAlert>
            ),
          });
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Calculations do not match.');
        }
      } else {
        logger.error(errorReason);
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('validation Failed');
      }
    });
  }

  checkValues() {
    const { indentDetails } = this.state;
    this.calculateFields();

    if (
      Number(indentDetails?.transporter_freight) !==
        Number(indentDetails?.ath_receivable) +
          Number(indentDetails?.bth_receivable) ||
      Number(indentDetails?.transporter_freight) !==
        Number(indentDetails?.ath_payable) +
          Number(indentDetails?.bth_payable) +
          Number(indentDetails?.gross_margin)
    )
      return false;
    return true;
  }

  async validateCreditBalance(payload) {
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;
    const endPoint = 'pipe/v2/validate-credit-balance';
    try {
      const response = await apiCaller(
        endPoint,
        payload,
        `Bearer ${token}`,
        'nh-base',
        'post'
      );
      const data = response?.data?.is_credit_limit;
      this.setState({ isCreditLimitExceeding: data });
      return response?.data?.is_credit_limit;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Submits the transporter details to the Database
   * @function
   */

  async submitTransaction() {
    const { classes, userDetails, systemDetails } = this.props;
    let { activeRole } = this?.props;
    let { indentNumber } = this.state;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const {
      athReceivableDate,
      expectedDate,
      showTds,
      hardCodeTransactionNumber,
      latestTransactionNumber,
      ewayBillNumber,
      indentDetails,
      advanceBonusTrucker,
      advanceBonusPaidByTrucker,
      advanceChargesTruckerAmount,
      advanceChargesTruckerShowinloadingslip,
      writeOffDeductionTruckerAmount,
      writeOffDeductionTransporterAmount,
    } = this.state;

    this.setState({ isLoading: true });
    const loadingDate = moment(indentDetails?.loading_date);
    const expected = moment(expectedDate);

    const truckerExpenseClaimed = [
      indentDetails?.loading_charges_paid_by_trucker,
      indentDetails?.unloading_charges_paid_by_trucker,
      indentDetails?.halting_charges_paid_by_trucker,
      indentDetails?.unloading_halting_charges_paid_by_trucker,
      indentDetails?.hamali_charges_paid_by_trucker,
    ].some(Boolean);

    if (truckerExpenseClaimed) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: 'block', marginTop: '-100px' }}
            title="Error"
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
          >
            Other expenses paid by the trucker can be claimed directly through
            the LOBB Truck App. Please ask the trucker to use the app to claim
            any such expenses.
          </SweetAlert>
        ),
        isLoading: false,
      });
      return;
    }

    if (
      (expected.isBefore(loadingDate, 'day') && loadingDate.isValid()) ||
      !expected.isValid()
    ) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: 'block', marginTop: '-100px' }}
            title="Error"
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
          >
            {expected.isValid()
              ? 'Expected date cannot be before loading date.'
              : 'Expected date required'}
          </SweetAlert>
        ),
        isLoading: false,
      });
      return; // stop submit transaction
    }

    // Block Trip Creation When Trip Threshold Exceeds
    // if (isThresholdExceeded) {
    //   this.setState({ isLoading: false });
    //   this.creditLimitAlert();
    //   return; // stop submit transaction
    // }

    // Check if transaction already created via indent
    try {
      const user = firebase.auth().currentUser;
      const { Aa: token } = user;
      const endPoint = `pipe/indent/auto-fill?role=${currentActiveRole}&indent_id=${indentNumber}`;
      await apiCaller(endPoint, {}, `Bearer ${token}`, 'nh-base', 'get');
    } catch (e) {
      swal('Error', `${e?.response?.data?.Error}`, 'error');
      logger.error(e?.response?.data?.Error);
      this.setState({ isLoading: false });
      return; // stop submit transaction
    }

    const validatePayload = {
      ath_receivable: indentDetails?.ath_receivable,
      amount: indentDetails?.transporter_freight,
      loading_charges_transporter: indentDetails?.loading_charges_transporter,
      loading_charges_paid_by_transporter:
        indentDetails?.loading_charges_paid_by_transporter,
      hamali_charges_transporter: indentDetails?.hamali_charges_transporter,
      hamali_charges_paid_by_transporter:
        indentDetails?.hamali_charges_paid_by_transporter,
      unloading_charges_transporter:
        indentDetails?.unloading_charges_transporter,
      unloading_charges_paid_by_transporter:
        indentDetails?.unloading_charges_paid_by_transporter,
      halting_charges_transporter: indentDetails?.halting_charges_transporter,
      halting_charges_paid_by_transporter:
        indentDetails?.halting_charges_paid_by_transporter,
      penalty_transporter_amount: indentDetails?.penalty_transporter_amount,
      challan_transporter_amount: indentDetails?.challan_transporter_amount,
      doc_charges_transporter_amount:
        indentDetails?.doc_charges_transporter_amount,
      fuel_charges_transporter_amount:
        indentDetails?.fuel_charges_transporter_amount,
      maamol_charges_transporter_amount:
        indentDetails?.maamol_charges_transporter_amount,
      tds_transporter_amount: indentDetails?.tds_transporter_amount,
      unloading_halting_charges_paid_by_transporter:
        indentDetails?.unloading_halting_charges_paid_by_transporter,
      unloading_halting_charges_transporter:
        indentDetails?.unloading_halting_charges_transporter,
      role: currentActiveRole,
      transporter_id: indentDetails?.transporter_id,
      branch_id: indentDetails.branch_id,
    };

    try {
      const hasCreditLimit = await this.validateCreditBalance(validatePayload);
      if (hasCreditLimit) {
        this.setState({ isLoading: false });
        this.creditLimitAlert();
        return; // stop submit transaction
      }
    } catch (error) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: 'block', marginTop: '-100px' }}
            title="Error"
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
          >
            Failed to verify credit availability
          </SweetAlert>
        ),
        isLoading: false,
      });
      return; // stop submit transaction
    }

    const sendValueTotransporterTdsDeducted = () =>
      latestTransactionNumber < hardCodeTransactionNumber || showTds;

    this.validateAllFields()
      .then(response => {
        const user = firebase.auth().currentUser;

        const getPoint = (points, index) => {
          const point = points?.[index];
          return point?.latitude
            ? { lat: point.latitude, lng: point.longitude }
            : null;
        };

        const getAddress = (points, index) =>
          points?.[index]?.location_name || null;

        const loadingSubLocation = getPoint(indentDetails?.loading_points, 0);
        const loadingSubLocationOne = getPoint(
          indentDetails?.loading_points,
          1
        );
        const loadingSubLocationTwo = getPoint(
          indentDetails?.loading_points,
          2
        );
        const unloadingSubLocation = getPoint(
          indentDetails?.unloading_points,
          0
        );
        const unloadingSubLocationOne = getPoint(
          indentDetails?.unloading_points,
          1
        );
        const unloadingSubLocationTwo = getPoint(
          indentDetails?.unloading_points,
          2
        );
        const address = getAddress(indentDetails?.loading_points, 0);
        const loadingAddressOne = getAddress(indentDetails?.loading_points, 1);
        const loadingAddressTwo = getAddress(indentDetails?.loading_points, 2);
        const addressUnloading = getAddress(indentDetails?.unloading_points, 0);
        const unloadingAddressOne = getAddress(
          indentDetails?.unloading_points,
          1
        );
        const unloadingAddressTwo = getAddress(
          indentDetails?.unloading_points,
          2
        );

        const {
          netCommission,
          totalReceivableAmount,
          totalPayableAmount,
          athPayableAutoCalculated,
          bthPayableAutoCalculated,
          earlySettlementSmartClubMembershipBonusPaidByTrucker,
          earlySettlementSmartClubMembershipBonusTrucker,
          isPodSubmittedAtUnloadingPoint,
          softPodAcceptedByTransporter,
        } = this.state;
        if (response) {
          const payload = {
            isEditedTransaction: false,
            agentId: user.uid,
            transporterName: indentDetails?.transporter_name,
            truckerName: indentDetails?.trucker_name,
            vehicleNumber: indentDetails?.truck_number,
            fromCity: indentDetails?.from_location,
            toCity: indentDetails?.to_location,
            amount: String(indentDetails?.transporter_freight),
            commission: String(indentDetails?.gross_margin),
            netCommission,
            athPayable: indentDetails?.ath_payable,
            bthPayable: indentDetails?.bth_payable,
            athReceivable: String(indentDetails?.ath_receivable),
            bthReceivable: indentDetails?.bth_receivable,
            hamaliChargesTrucker: indentDetails?.hamali_charges_trucker,
            haltingChargesTrucker: indentDetails?.halting_charges_trucker,
            loadingChargesTrucker: indentDetails?.loading_charges_trucker,
            unloadingChargesTrucker: indentDetails?.unloading_charges_trucker,
            hamaliChargesTransporter: indentDetails?.hamali_charges_transporter,
            haltingChargesTransporter:
              indentDetails?.halting_charges_transporter,
            loadingChargesTransporter:
              indentDetails?.loading_charges_transporter,
            unloadingChargesTransporter:
              indentDetails?.unloading_charges_transporter,
            hamaliChargesPaidByTrucker:
              indentDetails?.hamali_charges_paid_by_trucker,
            haltingChargesPaidByTrucker:
              indentDetails?.halting_charges_paid_by_trucker,
            loadingChargesPaidByTrucker:
              indentDetails?.loading_charges_paid_by_trucker,
            unloadingChargesPaidByTrucker:
              indentDetails?.unloading_charges_paid_by_trucker,
            hamaliChargesPaidByTransporter:
              indentDetails?.hamali_charges_paid_by_transporter,
            haltingChargesPaidByTransporter:
              indentDetails?.halting_charges_paid_by_transporter,
            loadingChargesPaidByTransporter:
              indentDetails?.loading_charges_paid_by_transporter,
            unloadingChargesPaidByTransporter:
              indentDetails?.unloading_charges_paid_by_transporter,
            unloadingHaltingChargesTransporter:
              indentDetails?.unloading_halting_charges_transporter,
            unloadingHaltingChargesPaidByTransporter:
              indentDetails?.unloading_halting_charges_paid_by_transporter,
            unloadingHaltingChargesTrucker:
              indentDetails?.unloading_halting_charges_trucker,
            unloadingHaltingChargesPaidByTrucker:
              indentDetails?.unloading_halting_charges_paid_by_trucker,
            challanTransporterAmount: indentDetails?.challan_transporter_amount,
            penaltyTransporterAmount: indentDetails?.penalty_transporter_amount,
            tdsTransporterAmount: indentDetails?.tds_transporter_amount,
            docChargesTransporterAmount:
              indentDetails?.doc_charges_transporter_amount,
            fuelChargesTransporterAmount:
              indentDetails?.fuel_charges_transporter_amount,
            maamolChargesTransporterAmount:
              indentDetails?.maamol_charges_transporter_amount,
            challanTruckerAmount: indentDetails?.challan_trucker_amount,
            penaltyTruckerAmount: indentDetails?.penalty_trucker_amount,
            tdsTruckerAmount: Number(indentDetails?.tds_trucker_amount),
            fuelChargesTruckerAmount:
              indentDetails?.fuel_charges_trucker_amount,
            docChargesTruckerAmount: indentDetails?.doc_charges_trucker_amount,
            maamolChargesTruckerAmount:
              indentDetails?.maamol_charges_trucker_amount,
            shortageChargesTruckerAmount:
              indentDetails?.shortage_charges_trucker_amount,
            lateDeliveryTruckerAmount:
              indentDetails?.late_delivery_trucker_amount,
            latePodTruckerAmount: indentDetails?.late_pod_trucker_amount,
            earlySettlementTruckerAmount:
              indentDetails?.early_settlement_trucker_amount,
            tdsTruckerShowinloadingslip:
              indentDetails?.tds_trucker_showinloadingslip,
            fuelChargesTruckerShowinloadingslip:
              indentDetails?.fuel_charges_trucker_showinloadingslip,
            docChargesTruckerShowinloadingslip:
              indentDetails?.doc_charges_trucker_showinloadingslip,
            maamolChargesTruckerShowinloadingslip:
              indentDetails?.maamol_charges_trucker_showinloadingslip,
            shortageChargesTruckerShowinloadingslip:
              indentDetails?.shortage_charges_trucker_showinloadingslip,
            lateDeliveryTruckerShowinloadingslip:
              indentDetails?.late_delivery_trucker_showinloadingslip,
            latePodTruckerShowinloadingslip:
              indentDetails?.late_pod_trucker_showinloadingslip,
            earlySettlementTruckerShowinloadingslip:
              indentDetails?.early_settlement_trucker_showinloadingslip,
            totalPayableAmount,
            totalReceivableAmount,
            loadingDate: loadingDate.format('MMM Do YY'),
            athReceivableDate: athReceivableDate.format('MMM Do YY'),
            truckerId: indentDetails?.trucker_id,
            transporterId: indentDetails?.transporter_id,
            branch: indentDetails?.branch,
            athPayableAutoCalculated,
            bthPayableAutoCalculated,
            truckNumber: indentDetails?.truck_number,
            truckType: indentDetails?.truck_type,
            loadingSubLocation,
            loadingSubLocationOne,
            loadingSubLocationTwo,
            unloadingSubLocation,
            unloadingSubLocationOne,
            unloadingSubLocationTwo,
            address,
            addressUnloading,
            ledgerId: indentDetails?.trucker_ledger_id,
            limitPayable: true,
            loadingAddress: address,
            loadingAddressOne,
            loadingAddressTwo,
            unloadingAddress: addressUnloading,
            unloadingAddressOne,
            unloadingAddressTwo,
            truckerPhoneNumber: indentDetails?.trucker_phone_number,
            riskStatus: 'green',
            currentVehicleStatus: 'Transaction Created',
            currentVehicleStatusUpdatedById: userDetails?.uid || '',
            currentVehicleStatusUpdatedByName: userDetails?.name || '',
            currentVehicleLocation: '',
            currentVehicleLocationLattitude: '',
            currentVehicleLocationLongitude: '',
            truckerPocName: indentDetails?.trucker_poc_name,
            truckerPocId: indentDetails?.trucker_poc_id,
            transporterPocId: indentDetails?.transporter_poc_id || '',
            transporterPocName: indentDetails?.transporter_poc_name || '',
            truckPlacedByName: '',
            truckPlacedById: '',
            orderRecievedByName: '',
            orderRecievedById: '',
            tonnage: indentDetails?.tonnage || '',
            expectedDate: expectedDate ? expectedDate.format('MMM Do YY') : '',
            driversPhoneNumber: indentDetails?.driver_number,
            createdBy: userDetails?.uid || '',
            createdByName: userDetails?.name || '',
            editedBy: '',
            editedByName: '',
            expressTrip: indentDetails?.is_express,
            tatTrip: !indentDetails?.is_express,
            tatExpressTime: String(indentDetails?.express_duration),
            supplyId: getFirstEightChars(indentDetails?.supply_id),
            demandId: getFirstEightChars(indentDetails?.demand_id),
            transporterTdsDeducted: sendValueTotransporterTdsDeducted(),
            ewayBillNumber,
            isPodSubmittedAtUnloadingPoint,
            softPodAcceptedByTransporter,
            fromAreaName: indentDetails?.from_area_name || '',
            toAreaName: indentDetails?.to_area_name || '',
            manufacturerId: indentDetails?.manufacturer_id || '',
            manufacturerName: indentDetails?.manufacturer_name || '',
            advanceBonusTrucker,
            advanceBonusPaidByTrucker,
            advanceChargesTruckerAmount,
            advanceChargesTruckerShowinloadingslip,
            earlySettlementSmartClubMembershipBonusPaidByTrucker,
            earlySettlementSmartClubMembershipBonusTrucker,
            writeOffDeductionTruckerAmount,
            writeOffDeductionTransporterAmount,
          };
          addTransaction(payload)
            .then(async res => {
              const transactionId = res?.data?.transaction_id;
              const auditBody = {
                data: {
                  ...payload,
                },
                collection: 'Transactions',
                updatedBy: userDetails.uid,
                systemDetails,
                type: 'Create Transaction',
                message: `${userDetails.email} created a new Transaction with GFV ${indentDetails?.transporter_freight}, Commission ${indentDetails?.gross_margin}, From ${indentDetails?.from_location} To ${indentDetails?.to_location}`,
              };
              auditLog(auditBody);
              this.updateIndent(transactionId);
              this.clearForm();
              this.setState({ isLoading: false });
            })
            .catch(err => {
              const errorBody = {
                message: `${userDetails.email} tried to create a new Transaction but FAILED`,
                status: 'fail',
                error: err,
                updatedBy: userDetails.uid,
                errorMessage: err.message,
                collection: 'Transactions',
                systemDetails,
              };
              auditLog(errorBody);
              if (err.message === 'Parameter Missing') {
                this.setState({
                  alert: (
                    <SweetAlert
                      error
                      style={{ display: 'block', marginTop: '-100px' }}
                      title="Error"
                      onConfirm={() => this.hideAlert()}
                      confirmBtnCssClass={`${classes.button} ${classes.success}`}
                    >
                      Please verify fields/calculations.
                    </SweetAlert>
                  ),
                });
                this.setState({ isLoading: false });
              } else {
                this.setState({
                  alert: (
                    <SweetAlert
                      error
                      style={{ display: 'block', marginTop: '-100px' }}
                      title="Error"
                      onConfirm={() => this.hideAlert()}
                      confirmBtnCssClass={`${classes.button} ${classes.success}`}
                    >
                      Oops! Something went wrong.
                    </SweetAlert>
                  ),
                });
                this.setState({ isLoading: false });
              }
              this.setState({ isLoading: false });
            });
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false,
        });
      });
  }

  /**
   * Will Clears ALl the State values after form submision
   * @function
   */
  clearForm() {
    const { classes } = this.props;

    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: 'block', marginTop: '-100px' }}
          title="Good job!"
          onConfirm={() => this.confirmAlert()}
          onCancel={() => this.confirmAlert()}
          confirmBtnCssClass={`${classes.button} ${classes.success}`}
        >
          Transaction Added Succeessfully
        </SweetAlert>
      ),
    });
    this.setState({
      transporterNameState: '',
      truckerNameState: '',
      fromCityState: '',
      toCityState: '',
      amountState: '',
      commissionState: '',
      truckNumberState: '',
      isLoading: false,
      bthReceivableState: '',
      bthPayableState: '',
      athReceivableState: '',
      athPayableState: '',
      athPayableAutoCalculated: '0',
      bthPayableAutoCalculated: '0',
      driverNumberState: '',
      expectedDateState: '',
      expectedDate: '',
      truckerATHPercentage: '0',
      truckerBTHPercentage: '0',
      latestTransactionNumber: '',
      ewayBillNumber: '',
      indentNumber: '',
      indentDetails: null,
    });
  }

  creditLimitAlert = () => {
    const { classes } = this.props;
    const {
      branchCreditLimit,
      alert,
      isCreditLimitExceeding,
      indentDetails,
    } = this.state;
    const creditLimitColors = this.getCreditLimitColors(
      branchCreditLimit?.branch_credit_percentage
    );

    const creditThresholdColor = this.getCreditLimitColors(
      branchCreditLimit?.trip_threshold_percentage
    );

    const isThresholdExceeded =
      Number(branchCreditLimit?.trips_without_advance_count) >=
      Number(branchCreditLimit?.current_threshold_trip_count);

    const isCreditLimitExceeded =
      Number(branchCreditLimit?.branch_credit_percentage) >= 100 ||
      isCreditLimitExceeding;

    if (!alert) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: 'block', marginTop: '-250px' }}
            title="Error"
            onCancel={() => this.hideAlert()}
            onConfirm={() => {
              this.setCreditLimitEditDialog(true);
              this.hideAlert();
            }}
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
            cancelBtnCssClass={`${classes.button} ${classes.white}`}
            confirmBtnText="Extend"
            cancelBtnText="Ok"
            showCancel
          >
            <div className={classes.colFlexCenter}>
              <p>
                <strong>{indentDetails?.transporter_name}</strong> has utilised{' '}
              </p>
              {isCreditLimitExceeded && (
                <p>
                  <strong style={{ color: '#D32F2F' }}>
                    {branchCreditLimit?.branch_credit_percentage}%
                  </strong>{' '}
                  of its selected branch credit limit.
                </p>
              )}
              {isThresholdExceeded && (
                <p>
                  <strong style={{ color: '#D32F2F' }}>
                    {branchCreditLimit?.trips_without_advance_count} /{' '}
                    {branchCreditLimit?.current_threshold_trip_count}
                  </strong>{' '}
                  of its trip credit limit.
                </p>
              )}
              <p>
                Please collect the outstanding advance/balance or request a
                credit limit extension to proceed.
              </p>
              {isCreditLimitExceeded && (
                <div
                  style={{
                    backgroundColor: creditLimitColors.bgColor,
                  }}
                  className={classes.creditOutstanding}
                >
                  <text style={{ color: '#3C3C3C', fontWeight: 400 }}>
                    <strong>{indentDetails?.branch}</strong> Branch Outstanding:
                  </text>
                  <span>
                    <text
                      style={{
                        color: creditLimitColors.color,
                        fontWeight: 600,
                      }}
                    >
                      {currencyFormat(
                        branchCreditLimit?.current_branch_outstanding
                      )}{' '}
                      ({branchCreditLimit?.branch_credit_percentage}%){' '}
                    </text>
                    <text style={{ color: '#484848', fontWeight: 400 }}>
                      /{' '}
                      {currencyFormat(branchCreditLimit?.current_branch_limit)}
                    </text>
                  </span>
                </div>
              )}

              {isThresholdExceeded && (
                <div
                  style={{
                    backgroundColor: creditThresholdColor.bgColor,
                    marginTop: '5px',
                  }}
                  className={classes.creditOutstanding}
                >
                  <text style={{ color: '#3C3C3C', fontWeight: 400 }}>
                    Trip Credit Threshold:
                  </text>
                  <span>
                    <text
                      style={{
                        color: creditThresholdColor.color,
                        fontWeight: 600,
                      }}
                    >
                      {branchCreditLimit?.trips_without_advance_count}
                    </text>
                    <text style={{ color: '#484848', fontWeight: 400 }}>
                      / {branchCreditLimit?.current_threshold_trip_count}
                    </text>
                  </span>
                </div>
              )}
            </div>
          </SweetAlert>
        ),
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { indentDetails, branchCreditLimit } = this.state;

    const transporterId = indentDetails?.transporter_id;
    const truckerId = indentDetails?.trucker_id;
    const branchId = indentDetails?.branch_id;
    const athPayable = indentDetails?.ath_payable;
    const bthPayable = indentDetails?.bth_payable;
    const commission = indentDetails?.gross_margin;
    const frieghtValue = indentDetails?.transporter_freight;

    // Transporter Change
    if (
      transporterId &&
      transporterId !== prevState.indentDetails?.transporter_id
    ) {
      this.tdsDeductedFlagHandler(transporterId);
      this.latestTransactionNumberFromApi();
      this.calculateFields();
    }

    // Trucker Change
    if (truckerId && truckerId !== prevState.indentDetails?.trucker_id) {
      this.getTdsDeduction(truckerId);
    }
    // ATH payable change
    if (athPayable && athPayable !== prevState.indentDetails?.ath_payable) {
      this.handleTruckerATHPercentage(athPayable, commission, frieghtValue);
    }
    // BTH payable change
    if (bthPayable && bthPayable !== prevState.indentDetails?.bth_payable) {
      this.handleTruckerBTHPercentage(bthPayable, commission, frieghtValue);
    }

    // Check if branch or transporter changed
    if (
      (transporterId !== prevState.indentDetails?.transporter_id ||
        branchId !== prevState.indentDetails?.branch_id) &&
      transporterId &&
      branchId
    ) {
      this.getCreditLimit(indentDetails?.transporter_id, branchId);
    }

    // Only show alert if branchCreditLimit or threshold changed and meets condition
    if (
      branchCreditLimit !== prevState.branchCreditLimit &&
      (branchCreditLimit?.branch_credit_percentage >= 100 ||
        Number(branchCreditLimit?.trips_without_advance_count) >=
          Number(branchCreditLimit?.current_threshold_trip_count))
    ) {
      this.creditLimitAlert();
    }
  }

  async getCreditLimit(transporterId, branchId) {
    let { activeRole } = this?.props;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;
    const endPoint = `pipe/transporter/v2/current-credit-limit?role=${currentActiveRole}&transporter_id=${transporterId}&branch_id=${branchId}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data;
      this.setState({ branchCreditLimit: data });
    } catch (e) {
      logger.error(e);
    }
  }

  async getIndentDetails() {
    let { activeRole } = this?.props;
    let { indentNumber } = this.state;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;
    const endPoint = `pipe/indent/auto-fill?role=${currentActiveRole}&indent_id=${indentNumber}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data?.data;
      this.setState({ indentDetails: data }, () =>
        this.applyPodSettingsFromIndent(data)
      );
      this.setState({
        expectedDate: data?.expected_delivery_date
          ? moment(data.expected_delivery_date)
          : '',
      });
    } catch (e) {
      swal('Error', `${e?.response?.data?.Error}`, 'error');
      logger.error(e?.response?.data?.Error);
    }
  }

  async updateIndent(id) {
    let { activeRole } = this?.props;
    let { indentNumber } = this.state;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;
    const body = {
      role: currentActiveRole,
      transaction_id: id,
      indent_id: indentNumber,
    };
    const endPoint = `pipe/indent/link-trip`;
    try {
      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
    } catch (e) {
      logger.error(e?.response?.data?.Error);
    }
  }

  async getTdsDeduction(truckerId, retries = 2) {
    const { classes } = this.props;
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const endPoint = `pipe/trucker-tds/status?trucker_id=${truckerId}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${Aa}`,
        'nh-base',
        'get'
      );
      const tdsDeclaration = response?.data?.trucker_tds_declaration_submitted;
      const validPanCheck = response?.data?.valid_pan;

      if (tdsDeclaration) {
        this.setState({
          tdsTruckerSubmitted: true,
        });
      } else {
        this.setState({
          tdsTruckerSubmitted: false,
        });
      }
      if (validPanCheck) {
        this.setState({
          validPan: true,
        });
      } else {
        this.setState({
          validPan: false,
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Please update a Valid PAN to continue using this Trucker.
            </SweetAlert>
          ),
        });
      }
    } catch (error) {
      logger.error(error);

      this.setState({
        validPan: false,
      });

      if (retries > 0) {
        this.getTdsDeduction(truckerId, retries - 1);
      } else {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Something Went Wrong, Please Try Again, Page Will Refresh in 2
              Seconds
            </SweetAlert>
          ),
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  }

  async tdsDeductedFlagHandler(transporterId, retries = 2) {
    let { activeRole, classes } = this?.props;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;

    const endPoint = `pipe/check-tds-deduction?role=${currentActiveRole}&transporter_id=${transporterId}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const value = response?.data?.is_tds_deduction;
      if (value === false) {
        this.setState({
          showTds: value,
        });
      }
    } catch (e) {
      logger.error(e);
      if (retries > 0) {
        this.tdsDeductedFlagHandler(transporterId, retries - 1);
      } else {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Something Went Wrong, Please Try Again, Page Will Refresh in 2
              Seconds
            </SweetAlert>
          ),
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  }

  async latestTransactionNumberFromApi(retries = 2) {
    const { classes } = this.props;
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;

    const endPoint = `pipe/latest-transaction-number`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const value = response?.data?.latest_transaction;

      this.setState({
        latestTransactionNumber: value,
      });
    } catch (e) {
      logger.error(e);
      if (retries > 0) {
        this.latestTransactionNumberFromApi(retries - 1);
      } else {
        this.setState({
          alert: (
            <SweetAlert
              error
              style={{ display: 'block', marginTop: '-100px' }}
              title="Error"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={`${classes.button} ${classes.success}`}
            >
              Something Went Wrong, Please Try Again, Page Will Refresh in 2
              Seconds
            </SweetAlert>
          ),
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  }

  autoCalculated() {
    const { classes } = this.props;
    const { athPayableAutoCalculated, bthPayableAutoCalculated } = this.state;
    return (
      <>
        <h3
          style={{
            fontSize: '16px',
            color: 'black',
            fontWeight: '400',
            margin: '10px 0px',
          }}
        >
          Auto Calculated
        </h3>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InputLabel className={classes.labelText}>ATH Payable</InputLabel>
            <h5 className={classes.h5NoMargin}>
              {athPayableAutoCalculated || 0}
            </h5>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InputLabel className={classes.labelText}>BTH Payable</InputLabel>
            <h5 className={classes.h5NoMargin}>
              {bthPayableAutoCalculated || 0}
            </h5>
          </GridItem>
        </GridContainer>
      </>
    );
  }

  deductions() {
    const { classes } = this.props;
    const { indentDetails } = this.state;

    return (
      <TripDeductionFields
        classes={classes}
        indentDetails={indentDetails}
        state={this.state}
      />
    );
  }

  otherExpenses() {
    const { classes } = this.props;
    const { indentDetails } = this.state;

    return <OtherExpenses classes={classes} indentDetails={indentDetails} />;
  }

  athReceivableDateChange(athReceivableDate) {
    this.setState({ athReceivableDate });
  }

  expectedDateChange(expectedDate) {
    this.setState({ expectedDate });
  }

  getCreditLimitColors(number) {
    let color;
    let bgColor;
    if (number <= 70) {
      color = '#0C60BC';
      bgColor = '#EDF0FA';
    } else if (number > 70 && number <= 85) {
      color = '#E06C00';
      bgColor = '#FFEFE1';
    } else if (number > 85) {
      color = '#D32F2F';
      bgColor = '#F9DDDC';
    }

    return { color, bgColor };
  }

  render() {
    const { classes, userDetails } = this.props;
    const {
      alert,
      transporterNameState,
      truckerNameState,
      branchState,
      fromCityState,
      toCityState,
      truckNumberState,
      amountState,
      commissionState,
      athReceivableState,
      athPayableState,
      bthPayableState,
      athReceivableDate,
      bthReceivableState,
      isLoading,
      expectedDate,
      driverNumberState,
      expectedDateState,
      featureFlagFiles,
      validPan,
      branchCreditLimit,
      isCreditLimitExceeding,
      indentNumber,
      indentDetails,
      isPodSubmittedAtUnloadingPoint,
      softPodAcceptedByTransporter,
      isPodSubmittedAtUnloadingPointDisabled,
      softPodAcceptedByTransporterDisabled,
    } = this.state;

    const now = moment();
    const startYear = now.month() < 3 ? now.year() - 1 : now.year();
    const endYear = startYear + 1;
    const financialYear = `FY ${startYear
      .toString()
      .slice(-2)}-${endYear.toString().slice(-2)}`;

    const transCreditLimitColor = this.getCreditLimitColors(
      branchCreditLimit?.branch_credit_percentage
    );

    const creditThresholdColor = this.getCreditLimitColors(
      branchCreditLimit?.trip_threshold_percentage
    );

    const isThresholdExceeded =
      Number(branchCreditLimit?.trips_without_advance_count) >=
      Number(branchCreditLimit?.current_threshold_trip_count);

    return (
      <div>
        {featureFlagFiles === 1 && <FeatureFlagToastAlert />}

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {alert}
            <Card>
              <CardHeader
                className={`${classes.cardHeader}`}
                color="info"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '5px',
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ display: 'flex' }}>
                  <CardIcon color="primary" className={`${classes.cardHeader}`}>
                    <SwapHoriz />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Add transaction <small />
                  </h4>
                </div>
                {indentDetails?.transporter_name &&
                  indentDetails?.branch_id &&
                  branchCreditLimit?.current_branch_limit && (
                    <div className={classes.creditLimitBar}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        <InfoIcon style={{ color: '#0C60BC', fontSize: 20 }} />
                        <text
                          style={{ color: '#0C60BC', fontWeight: 600 }}
                          color="#0C60BC"
                        >
                          Credit limit
                        </text>
                      </div>

                      <div
                        style={{
                          backgroundColor: creditThresholdColor.bgColor,
                        }}
                        className={classes.creditOutstanding}
                      >
                        <text style={{ color: '#3C3C3C', fontWeight: 400 }}>
                          Trip{' '}
                        </text>
                        <span>
                          <text
                            style={{
                              color: creditThresholdColor.color,
                              fontWeight: 600,
                            }}
                          >
                            {branchCreditLimit?.trips_without_advance_count}
                          </text>
                          <text style={{ color: '#484848', fontWeight: 400 }}>
                            / {branchCreditLimit?.current_threshold_trip_count}
                          </text>
                        </span>
                      </div>
                      <div
                        style={{
                          backgroundColor: transCreditLimitColor.bgColor,
                        }}
                        className={classes.creditOutstanding}
                      >
                        <text style={{ color: '#3C3C3C', fontWeight: 400 }}>
                          Branch O/S:
                        </text>
                        <span>
                          <text
                            style={{
                              color: transCreditLimitColor.color,
                              fontWeight: 600,
                            }}
                          >
                            {currencyFormat(
                              branchCreditLimit?.current_branch_outstanding
                            )}{' '}
                            ({branchCreditLimit?.branch_credit_percentage}
                            %) /{' '}
                          </text>
                          <text style={{ color: '#484848', fontWeight: 400 }}>
                            {currencyFormat(
                              branchCreditLimit?.current_branch_limit
                            )}
                          </text>
                        </span>
                      </div>
                    </div>
                  )}
              </CardHeader>
              <CardBody mt={5}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <div
                      className={classes.marginBottom10}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '20px',
                      }}
                    >
                      <CustomInput
                        labelText="Indent ID"
                        id="intentId"
                        formControlProps={{
                          fullWidth: true,
                          style: { paddingTop: '10px', marginBottom: '10px' },
                        }}
                        inputProps={{
                          onChange: event => {
                            const val = event.target.value;
                            if (isEightDigitAlphaNumeric(val)) {
                              this.setState(
                                {
                                  indentNumber: val,
                                  indentDetails: null,
                                },
                                () => this.applyPodSettingsFromIndent(null)
                              );
                            }
                          },
                          value: indentNumber,
                        }}
                      />
                      <Button
                        color="success"
                        disabled={indentNumber.length < 8}
                        onClick={() => this.getIndentDetails()}
                      >
                        Create Trip
                      </Button>
                    </div>
                  </GridItem>
                </GridContainer>
                {indentDetails && (
                  <>
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        className={classes.marginBottom10}
                      >
                        <InputLabel className={classes.label}>
                          Expected ATH Receivable Date{' '}
                          {!athReceivableDate && (
                            <span style={{ color: 'red' }}>*</span>
                          )}
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>
                          <Datetime
                            onChange={this.athReceivableDateChange}
                            value={athReceivableDate}
                            timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: 'Select Date' }}
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.label}>
                          Expected Delivery Date{' '}
                          {!expectedDate && (
                            <span style={{ color: 'red' }}>*</span>
                          )}
                          {indentDetails?.expected_delivery_date && (
                            <span style={{ color: 'green', fontSize: '10px' }}>
                              (Precomputed date based on history. Update if
                              needed.)
                            </span>
                          )}
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>
                          <Datetime
                            onChange={this.expectedDateChange}
                            value={expectedDate}
                            dateFormat="DD/MM/YYYY"
                            timeFormat={false}
                            inputProps={{ placeholder: 'Select Date' }}
                          />
                          {expectedDateState === 'This field is required' && (
                            <Danger>{expectedDateState}</Danger>
                          )}
                        </FormControl>
                      </GridItem>

                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <text
                          style={{
                            fontSize: '14px',
                            color: '#858585',
                            fontWeight: '500',
                          }}
                        >
                          POD Submitted at Unloading Point?
                        </text>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="POD Unloading Point"
                            name="POD Unloading Point"
                            value={isPodSubmittedAtUnloadingPoint}
                            onChange={this.handleChangeUnloadingPoint}
                            row
                          >
                            <FormControlLabel
                              value
                              control={<Radio size="small" color="primary" />}
                              label="Yes"
                              disabled={isPodSubmittedAtUnloadingPointDisabled}
                            />
                            <FormControlLabel
                              value={false}
                              control={<Radio size="small" color="primary" />}
                              label="No"
                              disabled={isPodSubmittedAtUnloadingPointDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <text
                          style={{
                            fontSize: '14px',
                            color: '#858585',
                            fontWeight: '500',
                          }}
                        >
                          Soft Pod Accepted By Transporter?
                        </text>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="Soft Pod Accepted By Transporter"
                            name="Soft Pod Accepted By Transporter"
                            value={softPodAcceptedByTransporter}
                            onChange={
                              this.handleChangeSoftPodAcceptedByTransporter
                            }
                            row
                          >
                            <FormControlLabel
                              value
                              control={<Radio size="small" color="primary" />}
                              label="Yes"
                              disabled={softPodAcceptedByTransporterDisabled}
                            />
                            <FormControlLabel
                              value={false}
                              control={<Radio size="small" color="primary" />}
                              label="No"
                              disabled={softPodAcceptedByTransporterDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="transactionType"
                              name="transactionType"
                              value={
                                indentDetails?.is_express ? 'Express' : 'TAT'
                              }
                              row
                            >
                              <FormControlLabel
                                value="TAT"
                                control={<Radio color="primary" />}
                                label="Normal"
                                disabled
                              />
                              <FormControlLabel
                                value="Express"
                                control={<Radio color="primary" />}
                                label="TAT & Express"
                                disabled
                              />
                            </RadioGroup>
                          </FormControl>
                          {indentDetails?.is_express &&
                            indentDetails?.express_duration && (
                              <h5 className={classes.h5NoMargin}>
                                {indentDetails?.express_duration} hrs
                              </h5>
                            )}
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            Transporter
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.transporter_name || '-'}
                          </h5>
                          {transporterNameState ===
                            'This field is required' && (
                            <Danger>{transporterNameState}</Danger>
                          )}
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            Transporter POC
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.transporter_poc_name || '-'}
                          </h5>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            Trucker
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.trucker_name || '-'}
                          </h5>
                          {truckerNameState === 'This field is required' && (
                            <Danger>{truckerNameState}</Danger>
                          )}
                          {this.state.tdsTruckerSubmitted === false && (
                            <Typography
                              style={{ fontSize: '12px', color: '#D14343' }}
                            >
                              TDS Declaration for {financialYear} not submitted
                            </Typography>
                          )}
                        </div>

                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            Trucker POC
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.trucker_poc_name || '-'}
                          </h5>
                        </div>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            Demand ID
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {getFirstEightChars(indentDetails?.demand_id) ||
                              '-'}
                          </h5>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Supply ID
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {getFirstEightChars(indentDetails?.supply_id) || '-'}
                        </h5>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            Branch
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.branch || '-'}
                          </h5>
                          {branchState === 'This field is required' && (
                            <Danger>{branchState}</Danger>
                          )}
                        </div>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Truck
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.truck_number || '-'}
                        </h5>
                        {truckNumberState === 'This field is required' && (
                          <Danger>{truckNumberState}</Danger>
                        )}
                      </GridItem>
                      <GridItem item xs={12} sm={12} md={6}>
                        <div style={{ marginBottom: '10px' }}>
                          <InputLabel className={classes.labelText}>
                            From City
                          </InputLabel>
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.from_location || '-'}
                          </h5>
                          {fromCityState === 'This field is required' && (
                            <Danger>{fromCityState}</Danger>
                          )}
                        </div>
                      </GridItem>
                      <GridItem item xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          To City
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.to_location || '-'}
                        </h5>
                        {toCityState === 'This field is required' && (
                          <Danger>{toCityState}</Danger>
                        )}
                      </GridItem>
                      <GridItem item xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          From Area
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.from_area_name || '-'}
                        </h5>
                      </GridItem>
                      <GridItem item xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          To Area
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.to_area_name || '-'}
                        </h5>
                      </GridItem>
                    </GridContainer>

                    <GridContainer
                      style={{
                        marginTop: '10px',
                        display: 'flex',
                      }}
                    >
                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Loading Points
                        </InputLabel>
                        {indentDetails?.loading_points?.map(name => (
                          <h5
                            key={name?.location_name}
                            className={classes.h5NoMargin}
                          >
                            {name?.location_name || '-'}
                          </h5>
                        ))}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Unloading Points
                        </InputLabel>
                        {indentDetails?.unloading_points?.map(name => (
                          <h5
                            key={name?.location_name}
                            className={classes.h5NoMargin}
                          >
                            {name?.location_name || '-'}
                          </h5>
                        ))}
                      </GridItem>
                    </GridContainer>
                    <GridContainer style={{ marginTop: '10px' }}>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        className={classes.marginBottom10}
                      >
                        <InputLabel className={classes.labelText}>
                          Truck Type
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.truck_type || '-'}
                        </h5>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Truck Hire
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.transporter_freight || 0}
                        </h5>
                        {amountState === 'This field is required' && (
                          <Danger>{amountState}</Danger>
                        )}
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        className={classes.marginBottom10}
                      >
                        <InputLabel className={classes.labelText}>
                          Gross Margin
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.gross_margin || 0}
                        </h5>

                        {commissionState === 'This field is required' && (
                          <Danger>{commissionState}</Danger>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          ATH Receivable
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.ath_receivable || 0}
                        </h5>

                        {athReceivableState === 'This field is required' && (
                          <Danger>{athReceivableState}</Danger>
                        )}
                      </GridItem>

                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        className={classes.marginBottom10}
                      >
                        <InputLabel className={classes.labelText}>
                          BTH Receivable
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.bth_receivable || 0}
                        </h5>
                        {bthReceivableState === 'This field is required' && (
                          <Danger>{bthReceivableState}</Danger>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Trucker ATH
                        </InputLabel>
                        <div
                          style={{ display: 'flex', alignItems: 'baseline' }}
                        >
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.ath_payable || 0}
                          </h5>
                          {athPayableState === 'This field is required' && (
                            <Danger>{athPayableState}</Danger>
                          )}
                          {this.state.truckerATHPercentage > 0 && (
                            <div
                              style={{
                                border:
                                  this.state.truckerATHPercentage <= 100
                                    ? '2px solid #3DAC16'
                                    : '2px solid #FF0000',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '10px',
                                padding: '3px',
                              }}
                            >
                              <Typography>
                                {this.state.truckerATHPercentage}%
                              </Typography>
                            </div>
                          )}
                        </div>
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        className={classes.marginBottom10}
                      >
                        <InputLabel className={classes.labelText}>
                          Trucker BTH
                        </InputLabel>
                        <div
                          style={{ display: 'flex', alignItems: 'baseline' }}
                        >
                          <h5 className={classes.h5NoMargin}>
                            {indentDetails?.bth_payable || 0}
                          </h5>
                          {bthPayableState === 'This field is required' && (
                            <Danger>{bthPayableState}</Danger>
                          )}
                          {this.state.truckerBTHPercentage > 0 && (
                            <div
                              style={{
                                border:
                                  this.state.truckerBTHPercentage <= 100
                                    ? '2px solid #3DAC16'
                                    : '2px solid #FF0000',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '10px',
                                padding: '3px',
                              }}
                            >
                              <Typography>
                                {this.state.truckerBTHPercentage}%
                              </Typography>
                            </div>
                          )}
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.label}>
                          Loading Date
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.loading_date
                            ? moment(indentDetails?.loading_date).format(
                                'DD/MM/YYYY'
                              )
                            : '-'}
                        </h5>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Tonnage
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.tonnage || '-'}
                        </h5>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <InputLabel className={classes.labelText}>
                          Driver Phone Number
                        </InputLabel>
                        <h5 className={classes.h5NoMargin}>
                          {indentDetails?.driver_number || '-'}
                        </h5>
                        {driverNumberState === 'This field is required' && (
                          <Danger>{driverNumberState}</Danger>
                        )}
                      </GridItem>
                    </GridContainer>

                    {userDetails.branches.length > 0 && (
                      <GridItem xs={12} sm={12} md={6} />
                    )}
                    <GridContainer style={{ marginTop: '20px' }}>
                      <GridItem xs={12} sm={12} md={12}>
                        {this.otherExpenses()}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        {this.deductions()}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        {this.autoCalculated()}
                      </GridItem>
                    </GridContainer>
                    {isLoading ? (
                      <CircularProgress
                        className={classes.progress}
                        style={{ color: purple[500] }}
                        thickness={7}
                      />
                    ) : (
                      <Button
                        color="info"
                        onClick={this.submitTransaction}
                        className={classes.updateProfileButton}
                        disabled={featureFlagFiles === 1 || validPan === false}
                      >
                        Submit
                      </Button>
                    )}
                    <Clearfix />
                  </>
                )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <CreditLimitEditDialog
          creditLimitEditDialog={this.state.creditLimitEditDialog}
          setCreditLimitEditDialog={this.setCreditLimitEditDialog}
          transporterId={indentDetails?.transporter_id}
          activeRole={this.props.activeRole}
          branch={indentDetails?.branch}
          TransporterPercentage={branchCreditLimit?.branch_credit_percentage}
          branchId={indentDetails?.branch_id}
          branchLimit={branchCreditLimit?.current_branch_limit}
          threshold={branchCreditLimit?.trips_without_advance_count}
          isThresholdExceeded={isThresholdExceeded}
          isCreditLimitExceeded={
            Number(branchCreditLimit?.branch_credit_percentage) >= 100 ||
            isCreditLimitExceeding
          }
        />
      </div>
    );
  }
}
AddTransactions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  userDetails: state.main.userDetails,
  isDetailedPage: state.transactions.isDetailedPage,
  transactions: state.transactions.transactions,
  systemDetails: state.main.systemDetails,
  activeRole: state.main.activeRole,
});

export default connect(mapStateToProps)(
  withStyles(AddTruckersStyle)(AddTransactions)
);
